// Generated file : do not modify
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Liste des Raisons
export class ReasonSelect {
  // Choix
  public choix: ReasonChoix[];
  // Placeholder du choix
  public selectPlaceholder: string;
  // Valeur sélectionnée
  public value: number;
  // texte saisi
  public text: string;
  // Placeholder du texte
  public textPlaceholder: string;
  // Longueur min du texte
  public textMinLength: number;
  // Longueur max du texte
  public textMaxLength: number;
  // Saisie valide
  public valid: boolean;

  constructor() {
    this.choix = [];
    this.selectPlaceholder = '';
    this.value = 0;
    this.text = '';
    this.textPlaceholder = '';
    this.textMinLength = 0;
    this.textMaxLength = 0;
    this.valid = false;
  }
}

export class ReasonChoix {
  // Libellé
  public label: string;
  // Texte additionnel à saisir
  public hasTextArea: boolean;
  // Texte additionnel requis
  public textRequired: boolean;

  constructor() {
    this.label = '';
    this.hasTextArea = false;
    this.textRequired = false;
  }
}

export default class Reason  {
  // Identifiant unique
  public id: number;
  // type de raison
  public reasonDefId: number;
  // Libellé du choix
  public label: string;
  // ordre
  public ordre: number;
  // Texte à saisir
  public hasTextArea: boolean;
  // Texte requis
  public textRequided: boolean;
  // Génère des frais
  public frais: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.reasonDefId = 0;
    this.label = '';
    this.ordre = 0;
    this.hasTextArea = false;
    this.textRequided = false;
    this.frais = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Reason): Reason {
    const newReason: Reason = new Reason();
    newReason.id = obj.id;
    newReason.reasonDefId = obj.reasonDefId;
    newReason.label = obj.label;
    newReason.ordre = obj.ordre;
    newReason.hasTextArea = obj.hasTextArea;
    newReason.textRequided = obj.textRequided;
    newReason.frais = obj.frais;
    newReason.canUpdate = obj.canUpdate;
    newReason.canDelete = obj.canDelete;
    newReason.display = obj.display;
    newReason.notifDefType = obj.notifDefType;
    return newReason;
  }

  public toJsonReason (): string {
    const json = {
      reasonDefId: this.reasonDefId,
      label: this.label,
      ordre: this.ordre,
      hasTextArea: this.hasTextArea,
      textRequided: this.textRequided,
      frais: this.frais,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromReason (obj: Reason): void {
    this.id = obj.id;
    this.reasonDefId = obj.reasonDefId;
    this.label = obj.label;
    this.ordre = obj.ordre;
    this.hasTextArea = obj.hasTextArea;
    this.textRequided = obj.textRequided;
    this.frais = obj.frais;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareReason (value: Reason): boolean {
    return (this.toJsonReason() == value.toJsonReason());
  }

  public cloneReason (): Reason {
    return Reason.fromJson(this);
  }

  // eslint-disable-next-line
  public static getDate(reasons: Reason[]) {
  }
}
